module.exports = __webpack_public_path__ + "img/logo.c3eb4370.jpg";